var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    style: {
      width: "inherit",
      height: "inherit",
      lineHeight: "inherit",
      color: "inherit"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 64.763L121 74.298l15.02 17.91H66.667V42.044c0-4.56-3.75-8.292-8.333-8.292s-8.333 3.731-8.333 8.292v66.748h84.073L121 124.38l11.5 9.535l25-29.767c5.333-6.384.25-9.203-25-39.385z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRight);
export default __webpack_public_path__ + "static/media/down-right.c3c84d98950acb9d4272a1335264b1c7.svg";
export { ForwardRef as ReactComponent };